import {IFlagshipBadgeProps} from "./FlagshipBadge.interfaces";
import {Brands} from "../../const";

export const useFlagshipBadge = (props: IFlagshipBadgeProps) => {
    const brand = Brands[props.brand];
    return {
        brand
    }
}